export default {
  state: {
    tags: []
  },
  mutations: {
    updateTags(state, tags) {
      state.tags = tags
    }
  },
  getters: {
    tags: state => state.tags,
  }
}
